import { FilterProps } from 'components/external-reference/Filter';
import { Box, Input, Stack } from '@mui/material';
import React from 'react';
import useBundleTranslation from 'i18n';

export default function RangeFilter({ filter, onFilterChange }: FilterProps) {
    const { t } = useBundleTranslation();
    const from = filter.selectedValues?.[0] ?? 0;
    const to = filter.selectedValues?.[1] ?? 0;

    const handleChange = (newValue: string, index: number) => {
        onFilterChange(filter.filterId, [index == 0 ? newValue : from, index == 1 ? newValue : to]);
    };

    return (
        <Stack spacing={1} direction={'row'}>
            <Box flexGrow={1}>
                <Input
                    type="text"
                    onChange={(event) => handleChange(event.target.value, 0)}
                    value={from}
                    fullWidth={true}
                    inputProps={{ 'data-1p-ignore': true }}
                />
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{t('to')}</Box>
            <Box flexGrow={1}>
                <Input
                    type="text"
                    onChange={(event) => handleChange(event.target.value, 1)}
                    value={to}
                    fullWidth={true}
                    inputProps={{ 'data-1p-ignore': true }}
                />
            </Box>
        </Stack>
    );
}
